import EmptyState from '@components/EmptyState'
import React from 'react'

const EmptyLessons: React.FC<{
  top?: 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'
}> = ({ top }) => (
  <EmptyState
    heading="All your lessons have been booked!"
    img="/images/all-lesson-booked.svg"
    linkUrl="/scheduling/my-calendar"
    btnTxt="Go to My calendar"
    top={top}
  />
)

export default EmptyLessons
